import React from "react";
import LegalPageLayout from "../../organisms/LegalPageLayout";

const PrivacyPage = () => {
    return (
        <LegalPageLayout
            className="privacy-page"
            eyebrow="MUZONE"
            title="Privacy Policy"
            titleId="privacy-policy-title"
            meta="Effective date: March 18, 2026"
            lead={
                <>
                    MUZONE is a music collaboration platform. This policy explains what information we collect,
                    how we use it, and how Google OAuth and Gmail API access are used in connection with the service.
                </>
            }
        >
            <section className="legal-page__section">
                <h2>Information We Collect</h2>
                <p>We may collect and store the following categories of information:</p>
                <ul>
                    <li>Account details such as email address, username, and authentication identifiers.</li>
                    <li>Profile content, messages, posts, band information, event data, and uploaded media.</li>
                    <li>Technical data such as IP address, device information, browser details, and security logs.</li>
                    <li>Usage and operational data needed to maintain, secure, and improve the platform.</li>
                </ul>
            </section>

            <section className="legal-page__section">
                <h2>How We Use Information</h2>
                <p>We use information to operate MUZONE, including to:</p>
                <ul>
                    <li>Create and secure user accounts.</li>
                    <li>Authenticate sign-ins and protect against fraud or abuse.</li>
                    <li>Deliver transactional emails such as verification codes, password reset links, and security notices.</li>
                    <li>Provide collaboration, discovery, messaging, and community features inside the product.</li>
                    <li>Monitor system health, troubleshoot incidents, and improve service reliability.</li>
                </ul>
            </section>

            <section className="legal-page__section">
                <h2>Google OAuth and Google User Data</h2>
                <p>
                    MUZONE may use Google OAuth to sign users in. When a user chooses Google sign-in, MUZONE
                    receives only the Google account information needed to authenticate the user and create or
                    link their MUZONE account.
                </p>
                <p>
                    MUZONE also uses the Gmail API for a service-owned sender mailbox to deliver transactional
                    emails from MUZONE. MUZONE requests the narrow Gmail scope <code>gmail.send</code> for that
                    purpose only.
                </p>
                <p>
                    MUZONE does not use Gmail API access to read mailbox contents, access contacts, or inspect
                    end-user email data. Gmail API access is used only to send MUZONE account and security emails.
                </p>
                <p>
                    MUZONE&apos;s use and transfer of information received from Google APIs adheres to the
                    Google API Services User Data Policy, including the Limited Use requirements.
                </p>
            </section>

            <section className="legal-page__section">
                <h2>Sharing</h2>
                <p>
                    We do not sell personal information. We may share information only with infrastructure and
                    service providers that help us operate MUZONE, or when required by law, enforceable legal
                    process, or to protect the rights, safety, and security of MUZONE, its users, or the public.
                </p>
            </section>

            <section className="legal-page__section">
                <h2>Retention and Security</h2>
                <p>
                    We retain information only for as long as it is reasonably needed for service operation,
                    security, legal compliance, or dispute resolution. We use technical and organizational
                    safeguards designed to protect account data, authentication data, and operational records.
                </p>
            </section>

            <section className="legal-page__section">
                <h2>Your Choices</h2>
                <p>
                    You may request account-related assistance or ask questions about privacy and data handling by
                    contacting us at <a href="mailto:muzone.me@gmail.com">muzone.me@gmail.com</a>.
                </p>
            </section>

            <section className="legal-page__section">
                <h2>Contact</h2>
                <p>
                    If you have questions about this policy or MUZONE&apos;s use of Google APIs, contact
                    <a href="mailto:muzone.me@gmail.com"> muzone.me@gmail.com</a>.
                </p>
            </section>
        </LegalPageLayout>
    );
};

export default PrivacyPage;
